import { useRef } from 'react';
import { Paper, PaperProps } from '@mui/material';
import Draggable from 'react-draggable';

export default function DraggableComponent(props: PaperProps) {
  const dragef = useRef(null);
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
      nodeRef={dragef}
      bounds="body"
    >
      <Paper ref={dragef} {...props} />
    </Draggable>
  );
}
